const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        promotionalCode: {},
        expired: false,
        roboPromoCodeError: false,
    });
};

const initialState = setInitialState();

const promotionalCodeReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_PROMO_CODE_RESULT:
            return state.merge({
                promotionalCode: Immutable.Map({
                    code: action.data.promotionalCode.code,
                    status: action.data.status,
                    title: action.data.promotionalCode.title,
                    details: action.data.promotionalCode.subTitle,
                    img: action.data.promotionalCode.urlImg,
                    url: action.data.promotionalCode.url,
                    isRoboPromoCode: action.data.promotionalCode.isRoboPromoCode,
                }),
                expired: false,
            });
        case actionTypes.CLEAR_PROMO_CODE_RESULT:
            return state.merge({
                promotionalCode: {},
                expired: false,
            });
        case actionTypes.SET_PROMO_CODE_EXPIRED:
            return state.merge({
                promotionalCode: Immutable.Map({
                    status: action.data.status,
                }),
                expired: true,
            });
        case actionTypes.SET_PROMO_CODE_ERROR_ROBO:
            return state.merge({
                roboPromoCodeError: true,
            });
        case actionTypes.RESET_PROMO_CODE_ERROR_ROBO:
            return initialState;
        default:
            return state;
    }
};

module.exports = promotionalCodeReducer;
